import React, { useState } from 'react';
import { supabase } from '../webSupabaseClient';
import { toast } from 'react-toastify';
import { webLogger } from '../utils/webLogger';

function PasswordChangeForm() {
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault(); 
        setLoading(true);
        webLogger.log('PasswordChangeForm: Şifre değiştirme isteği gönderiliyor.');
        try {
            const { error } = await supabase.auth.updateUser({ password: password });
            if (error) throw error;
            toast.success("Şifreniz başarıyla güncellendi.");
            webLogger.log('PasswordChangeForm: Şifre başarıyla güncellendi.');
            setPassword('');
        } catch (err) { 
            webLogger.error('PasswordChangeForm: Şifre güncellenirken hata.', { message: err.message });
            toast.error(err.message); 
        } 
        finally { setLoading(false); }
    };

    return(
        <div>
            <h3 className="text-xl font-bold text-gray-800 mb-4">Şifre Değiştirme</h3>
            <form onSubmit={handleSubmit} className="space-y-4 max-w-sm">
                <div>
                    <label htmlFor="new_password" className="block text-sm font-medium text-gray-700">Yeni Şifre</label>
                    <input 
                        type="password" 
                        name="new_password" 
                        id="new_password" 
                        required 
                        minLength="6" 
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)} 
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-brand-green focus:border-brand-green" 
                        placeholder="En az 6 karakter"
                    />
                </div>
                <button 
                    type="submit" 
                    disabled={loading} 
                    className="w-full bg-brand-green hover:bg-brand-green-light text-white font-bold py-2 px-4 rounded-lg disabled:opacity-50"
                >
                    {loading ? 'Kaydediliyor...' : 'Yeni Şifreyi Kaydet'}
                </button>
            </form>
        </div>
    );
}

export default PasswordChangeForm;